import { useApp } from '@/app/AppContext'
import { openPalette } from '@/components/CommandPalette'
import { Icon } from '@/components/Icon'
import { ErrorActions, QuickLinks, SupportCode, useRequestedPath } from './errorParts'

/**
 * «Страница не найдена», вёрстка по Err404.dc.html.
 *
 * Та же страница закрывает и запись, которой нет в области видимости: клиент не может
 * отличить «удалена» от «не ваша», и оба случая значат «этой записи для вас нет». Поэтому
 * текст называет обе причины, а не угадывает одну. Подсказки «запись удалена — см. журнал
 * аудита» из макета нет: сервер не говорит, была ли запись и кто её удалил.
 *
 * Поиск — та же палитра команд (Ctrl K), а не второй поиск со своими правилами; разделы —
 * только доступные пользователю.
 */
export function NotFound() {
  const { t } = useApp()
  const path = useRequestedPath()
  return (
    <div className="err-page">
      <div className="state-box err-box">
        <div className="state err-state" role="status">
          <span className="err-code" aria-hidden="true">404</span>
          <span className="state-kind">
            <Icon name="search" size="xs" />
            {t('err.404.kind')}
          </span>
          <h1 className="st err-title">{t('page.notFound')}</h1>
          <p className="sd">
            {t('err.404.lead.before')} <span className="mono err-path">{path}</span> {t('err.404.lead.after')}
          </p>
          <div className="err-reasons">
            <div className="err-reason">
              <Icon name="link" className="muted" />
              <span className="stack">
                <span className="strong">{t('err.404.stale')}</span>
                <span className="t-sm secondary">{t('err.404.stale.text')}</span>
              </span>
            </div>
            <div className="err-reason">
              <Icon name="trash" className="muted" />
              <span className="stack">
                <span className="strong">{t('err.404.deleted')}</span>
                <span className="t-sm secondary">{t('err.404.deleted.text')}</span>
              </span>
            </div>
          </div>
          <div className="field err-block">
            <span className="label">{t('err.404.find')}</span>
            <button type="button" className="input select err-search" onClick={() => openPalette()}>
              <span className="row" style={{ gap: 8 }}>
                <Icon name="search" size="sm" className="muted" />
                <span className="muted">{t('err.404.find.placeholder')}</span>
              </span>
              <span className="kbd">Ctrl K</span>
            </button>
          </div>
          <QuickLinks />
          <ErrorActions primary />
          <SupportCode code={404} path={path} />
        </div>
      </div>
    </div>
  )
}
